import React, { useEffect, useState } from "react";
import { useApi } from "../../../../hooks/useApi";
import LineBtn from "../../../Button/LineBtn";
import LineBox from "../../../DefaultStyles/LineBox";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import {
  getLPointShowValue,
  getThousandComma,
} from "../../../../Api/ApiCommon";
import AlertModal from "../../../Modal/AlertModal";
import ExcelDownload from "../../../DefaultStyles/ExcelDownload";
import CancelPointModal from "./ScheduledPoint/CancelPointModal";
import Loader from "../../../DefaultStyles/Loader";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { authType } from "../../../../pages/Login";
import { useNavigate } from "react-router-dom";
import Flex from "../../../DefaultStyles/Flex";
import { PartyInfoFilterContainer } from "../../Party/PartyInfo/PartyInfoFilter";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import { TotalCount } from "../../../../pages/Users/UserInfo";
import { toast } from "react-toastify";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import moment from "moment";

interface IPoint {
  code: string;
  count: string;
  id: string;
  promotion?: string;
  schedday: string;
  uid: string;
  val?: number;
  total?: number;
  regdate: string;
}

export const scheduledPointPageState = atom<number>({
  key: "scheduledPointPageState",
  default: 0,
});

export default function ScheduledPoint() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();
  const [savedPage, setSavedPage] = useRecoilState<number>(scheduledPointPageState);

  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(0);
  }, []);
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [filterDropdown, setFilterDropdown] = useState<OptionType>({
    value: "",
    label: "전체",
  });

  const [userUid, setUserUid] = useState("");
  const [cancelBtnClick, setCancelBtnClick] = useState({
    modal: false,
    uid: "",
    pointId: "",
  });
  const [pointCancelModal, setPointCancelModal] = useState(false);
  const [filter, setFilter] = useState({
    isSchedule: 2,
  });

  const { response, loading, error } = useApi({
    method: "get",
    url:
      `point/schedule?page=${page}&size=10&isSchedule=${
        filter?.isSchedule !== 2 ? filter?.isSchedule : 0
      }` +
      (searchValue !== "" ? `&${dropDownValue?.value}=${searchValue}` : ``),
  });

  const { response: userData, loading: userLoading } = useApi({
    method: "get",
    url: userUid ? `user/${userUid}` : undefined,
  });

  const tableHead = [
    "ID",
    "UID",
    "Promotion",
    "Code",
    "적립 횟수",
    "적립 예정 포인트",
    "실행 예정일",
    "누적 적립 포인트",
    "지급 일시",
    "취소",
  ];

  const couponPointOptionList = [
    { value: "uid", label: "UID" },
    { value: "name", label: "이름" },
    { value: "nickname", label: "닉네임" },
    { value: "phone", label: "전화번호" },
    { value: "code", label: "포인트 코드" },
    { value: "lppromid", label: "Promotion ID" },
  ];

  const filterOptionList = [
    { value: "0", label: "전체" },
    { value: "1", label: "적립 예정" },
  ];

  useEffect(() => {
    if (userData?.status === 200) {
      setCancelBtnClick({
        ...cancelBtnClick,
        modal: true,
        uid: `${userData?.data?.uid}_${userData?.data?.name}_${userData?.data?.nickname}`,
      });
    }
  }, [userData]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "포인트 등록 내역 불러오기에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      <PartyInfoFilterContainer>
        <Flex gapSize={10}>
          <DropDown
            setDropDownValue={setDropDownValue}
            optionList={couponPointOptionList}
            dropdownValue={dropDownValue}
          />

          <Search
            setSearchValue={setSearchValue}
            placeholder="입력"
            isDisabled={dropDownValue ? false : true}
            pageResetEvent={() => setPage(0)}
            inputType={
              dropDownValue?.value === "lppromid" ||
              dropDownValue?.value === "phone" ||
              dropDownValue?.value === "uid"
                ? "number"
                : undefined
            }
          />
        </Flex>

        <Flex gapSize={10}>
          <FilterIcon />

          <DropDown
            dropdownValue={filterDropdown}
            setDropDownValue={setFilterDropdown}
            optionList={filterOptionList}
            boxWidth={180}
          />

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnClickEvent={() => {
              setPage(0);
              setFilter({
                isSchedule: Number(filterDropdown?.value ?? 2),
              });
            }}
          />
        </Flex>
      </PartyInfoFilterContainer>

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={879}>
          <>
            {response?.data?.items?.map((d: IPoint) => {
              return (
                <TableBody key={d?.id}>
                  <TableBodyItem>{d?.id}</TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                    onClick={() => {
                      setSavedPage(page);
                      navigate(`/users/info/${d?.uid}`);
                    }}
                  >
                    {d?.uid}
                  </TableBodyItem>
                  <TableBodyItem>{d?.promotion ?? "-"}</TableBodyItem>
                  <TableBodyItem>{d?.code ?? "-"}</TableBodyItem>
                  <TableBodyItem>{d?.count ?? "-"}</TableBodyItem>
                  <TableBodyItem>
                    {d?.val ? getLPointShowValue(d?.val + "") : "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.schedday === "" ? "완료" : d?.schedday ?? "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.total ? getLPointShowValue(d?.total + "") : "-"}
                  </TableBodyItem>

                  <TableBodyItem>
                    {d?.regdate !== ""
                      ? moment(d?.regdate).format("YYYY-MM-DD HH:mm")
                      : "-"}
                  </TableBodyItem>

                  <TableBodyItem>
                    <LineBtn
                      btnText="취소"
                      btnClickEvent={() => {
                        setCancelBtnClick({
                          modal: true,
                          uid: d?.uid,
                          pointId: d?.id,
                        });
                        setUserUid(d?.uid);
                      }}
                      disabled={!auth?.couponAndPoint}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
            pageSize={response?.status === 200 ? +response?.data?.pageSize : 0}
            totalCount={
              response?.status === 200 ? response?.data?.totalCount : 0
            }
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <ExcelDownload
        tableHead={tableHead}
        pushedData={(e: any) => {
          return [
            e.id,
            e.uid,
            e.promotion,
            e.code,
            e?.count ?? "-",
            e?.val ? getLPointShowValue(e?.val + "") : "-",
            e?.schedday === "" ? "완료" : e?.schedday ?? "-",
            e?.total ? getLPointShowValue(e?.total + "") : "-",
          ];
        }}
        dataUrl={
          searchValue !== ""
            ? `point/schedule?page=0&size=1000&isSchedule=${
                filter?.isSchedule !== 2 ? filter?.isSchedule : 0
              }&${dropDownValue?.value}=${searchValue}`
            : `point/schedule?page=${page}&size=1000&isSchedule=${
                filter?.isSchedule !== 2 ? filter?.isSchedule : 0
              }`
        }
        disabled={response?.data?.items?.length < 1}
        title="적립 예정 포인트"
      />

      {cancelBtnClick?.modal && (
        <AlertModal
          title={`${cancelBtnClick?.uid}님의 예정된 포인트 지급이 취소됩니다.
      계속 하시겠습니까?`}
          cancelEvent={() =>
            setCancelBtnClick({
              ...cancelBtnClick,
              modal: false,
            })
          }
          confirmText="계속"
          confirmEvent={() => {
            setCancelBtnClick({
              ...cancelBtnClick,
              modal: false,
              uid: "",
            });
            setPointCancelModal(true);
          }}
        />
      )}

      {pointCancelModal && (
        <CancelPointModal
          cancelEvent={() => setPointCancelModal(false)}
          closeEvent={() => {
            setPointCancelModal(false);
          }}
          pointId={cancelBtnClick?.pointId}
        />
      )}

      {(loading || userLoading) && <Loader />}
    </>
  );
}
